var map = {
	"./EnergyReport.eneco.nl-NL.json": [
		4603,
		4603
	],
	"./EnergyReport.oxxio.nl-NL.json": [
		50386,
		386
	],
	"./EnergyReport.woonenergie.nl-NL.json": [
		98561,
		8561
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 97756;
module.exports = webpackAsyncContext;